import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-8">
            关于色影视
          </h2>

          <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {aboutData.description}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <span className="block text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}